module.exports = __webpack_public_path__ + "img/allow-to-open.debda4db.png";